import { render, staticRenderFns } from "./ShopShow.vue?vue&type=template&id=fb6e20dc&scoped=true&"
import script from "./ShopShow.vue?vue&type=script&lang=js&"
export * from "./ShopShow.vue?vue&type=script&lang=js&"
import style0 from "./ShopShow.vue?vue&type=style&index=0&id=fb6e20dc&scoped=true&lang=css&"
import style1 from "./ShopShow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6e20dc",
  null
  
)

export default component.exports